module.exports = __webpack_public_path__ + "media/common/images/innogy_style/values-c8960f32d83f46ba609f98833a483fdf.svg";